module.exports = __webpack_public_path__ + "img/curved6.b31b3715.jpg";